// extracted by mini-css-extract-plugin
module.exports = {"root":"Loader_root__2QdDo","indicator":"Loader_indicator__1I_zN","back":"Loader_back__3xGr_","front":"Loader_front__1aONt","dash":"Loader_dash__1jv6B"};